import { useState, useEffect, Fragment } from "react";
import Nuevo from "./Nuevo.jsx";
import Presentacion from "./Presentacion.jsx";
import Aportantes from "./Aportantes.jsx";
import Actividades from "./Actividades.jsx";
import Usuarios from "./Usuarios.jsx";
import Indicador from "./Indicador.jsx";
import { Tab, Tabs } from "@mui/material";
import AddchartIcon from "@mui/icons-material/Addchart";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import EngineeringIcon from "@mui/icons-material/Engineering";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import { getCombos } from "../componentes/api.js";

const Proyectos = (props) => {
  const [pantalla, setPantalla] = useState(0);
  const [idProyecto, setIdProyecto] = useState("");
  const [proyectos, setProyectos] = useState([]);

  const handleChange = (event, value) => {
    event.preventDefault();
    setPantalla(value);
  };

  const asignarProyecto = (id) => {
    cargarProyectos();
    setIdProyecto(id);
  };

  const cargarProyectos = async () => {
    try {
      const response = await getCombos(
        { Tabla: "proyectos", Campo: "" },
        "cboProyectos"
      );
      setProyectos(response.data);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar los Proyectos",
        error,
      ]);
    }
  };

  const mostrarPantalla = () => {
    if (pantalla === 0) {
      return (
        <Nuevo
          idUsuario={props.perfil.Id}
          asignarProyecto={asignarProyecto}
          mostrarMsg={props.mostrarMsg}
        />
      );
    } else if (pantalla === 1) {
      return (
        <Presentacion
          Ruta={"proyectos/presentacion"}
          Tabla={"proyectos"}
          Campo={"Presentacion"}
          Id={idProyecto}
          UsuarioReg={props.perfil.Id}
          Img={props.perfil.Presentacion}
          mostrarMsg={props.mostrarMsg}
        />
      );
    } else if (pantalla === 2)
      return (
        <Aportantes
          idUsuario={props.perfil.Id}
          idProyecto={idProyecto}
          mostrarMsg={props.mostrarMsg}
        />
      );
    else if (pantalla === 3)
      return (
        <Actividades
          IdUsuario={props.perfil.Id}
          IdProyecto={idProyecto}
          mostrarMsg={props.mostrarMsg}
          llamador={"Proyectos"}
        />
      );
    else if (pantalla === 4)
      return (
        <Usuarios
          idUsuario={props.perfil.Id}
          idProyecto={idProyecto}
          mostrarMsg={props.mostrarMsg}
        />
      );
    else if (pantalla === 5)
      return (
        <Indicador
          idUsuario={props.perfil.Id}
          idProyecto={idProyecto}
          mostrarMsg={props.mostrarMsg}
        />
      );
  };

  useEffect(() => {
    cargarProyectos();
  }, []);

  return (
    <>
      <Fragment>
        <div className="container-fluid">
          <div className="row">
            <Tabs
              value={pantalla}
              onChange={handleChange}
              aria-label="icon label tabs example"
            >
              <Tab icon={<AddchartIcon />} label="Nuevo" />
              <Tab icon={<VideoLibraryIcon />} label="Presentación" />
              <Tab icon={<CurrencyExchangeIcon />} label="Aportantes" />
              <Tab icon={<EngineeringIcon />} label="Actividades" />
              <Tab icon={<PersonOutlineIcon />} label="Usuarios" />
              <Tab icon={<Diversity3Icon />} label="Indicadores" />
            </Tabs>
          </div>

          <div className="container-fluid card shadow mt-2 mb-3">
            <div className="form-floating mb-2 mt-2">
              <select
                type="text"
                className="form-control"
                name="idProyecto"
                value={idProyecto}
                onChange={(event) => {
                  setIdProyecto(event.target.value);
                }}
              >
                <option key="0" value="0">
                  Por favor seleccione un Proyecto...
                </option>
                {proyectos.map((reg) => {
                  return (
                    <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                      {" "}
                      {reg.Nbre}{" "}
                    </option>
                  );
                })}
              </select>
              <label htmlFor="idProyecto">Proyecto Actual</label>
            </div>
          </div>

          <div className="row">{mostrarPantalla()}</div>
        </div>
      </Fragment>
    </>
  );
};

export default Proyectos;
